import template from './calendarInlineCard.html';
import './calendarInlineCard.scss';

let calendarInlineCardComponent = {
  restrict: 'E',
  bindings: {
    employee: '<',
    inceptEmployee: '&',
    isDisabled: '<'
  },
  template,
};

export default calendarInlineCardComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineCard/calendarInlineCard.component.js